import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { TitleOfferFragmentDoc, FastOfferFragmentDoc } from '../fragments/Offer.fragment';
export type GetGeoSwiperOffersQueryVariables = Types.Exact<{
	nodeId: Types.Scalars['ID']['input'];
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	platform?: Types.Platform;
	filter: Types.OfferFilter;
}>;

export type GetGeoSwiperOffersQuery = {
	__typename?: 'Query';
	node?:
		| { __typename: 'Article'; id: string }
		| { __typename: 'Author'; id: string }
		| { __typename: 'Bundle'; id: string }
		| { __typename: 'Device'; id: string }
		| { __typename: 'Episode'; id: string }
		| { __typename: 'GenericTitleList'; id: string }
		| { __typename: 'Genre'; id: string }
		| { __typename: 'HomePage'; id: string }
		| {
				__typename: 'Movie';
				id: string;
				geoOffers: Array<{
					__typename: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
		  }
		| { __typename: 'MultiStepSportEvent'; id: string }
		| { __typename: 'Offer'; id: string }
		| { __typename: 'OfferHistory'; id: string }
		| { __typename: 'Package'; id: string }
		| { __typename: 'Page'; id: string }
		| { __typename: 'Person'; id: string }
		| { __typename: 'ProfileV2'; id: string }
		| {
				__typename: 'Season';
				id: string;
				geoOffers: Array<{
					__typename: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
		  }
		| {
				__typename: 'Show';
				id: string;
				geoOffers: Array<{
					__typename: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
		  }
		| { __typename: 'SingleStepSportEvent'; id: string }
		| { __typename: 'SportCompetitionV2'; id: string }
		| { __typename: 'SportCompetitorV2'; id: string }
		| { __typename: 'SportMatch'; id: string }
		| { __typename: 'Url'; id: string }
		| null;
};

export const GetGeoSwiperOffersDocument = gql`
	query GetGeoSwiperOffers(
		$nodeId: ID!
		$country: Country!
		$language: Language!
		$platform: Platform! = WEB
		$filter: OfferFilter!
	) {
		node(id: $nodeId) {
			id
			__typename
			... on MovieOrShowOrSeason {
				__typename
				geoOffers: offers(country: $country, platform: $platform, filter: $filter) {
					__typename
					id
					...TitleOffer
				}
			}
		}
	}
	${TitleOfferFragmentDoc}
`;
